<template>
  <div ref="mainbody" id="main-wrapper">
    <!-- ============================================================== -->
    <!-- Topbar header - style you can find in pages.scss -->
    <!-- ============================================================== -->
    <header ref="topbar" class="topbar">
      <nav class="navbar top-navbar navbar-expand-md navbar-light">
        <div class="navbar-collapse">
          <!-- ============================================================== -->
          <!-- toggle and nav items -->
          <!-- ============================================================== -->
          <ul class="navbar-nav my-lg-0">
            <!-- This is the menu icon-->
            <li class="nav-item" v-on:click="toggleSidebar"><a class="nav-link nav-toggler hidden-md-up waves-effect waves-dark"><i
              class="ti-menu"></i></a></li>
            <li class="nav-item" v-on:click="toggleSidebar"><a class="nav-link sidebartoggler hidden-sm-down waves-effect waves-dark"><i
              class="ti-menu"></i></a></li>

            <li class="nav-item">
              <span id="title" class="align-center" style="color: black;">{{ meeting_info.name }}</span>
            </li>
            <li class="nav-item" id="meeting-type">
              <span class="text-muted align-center subtitle">{{ $t(meeting_info.meeting_type) }}</span>
            </li>
          </ul>

          <ul class="navbar-nav ml-auto">
            <li class="nav-item buttons">
              <span class="align-center">
                <router-link to="/planmeeting" class="btn btn-rounded btn-info btn-sm align-center btn-small">
                  <i class="ti-plus"></i>
                  {{ $t("Plan meeting") }}
                </router-link>
              </span>
            </li>

            <li class="nav-item buttons">
              <span class="align-center">
                <a @click="showModal = true" class="btn btn-rounded btn-info btn-sm align-center btn-small">
                  <i class="ti-plus"></i>
                  {{ $t("Add action") }}
                </a>
              </span>
            </li>

            <li id="time" class="nav-item">
              <span class="align-center" style="color: black;"><i class="ti-time"></i></span>
              <span class="align-center" style="color: black;" v-bind:class="{'text-danger': total_time > total_max_time }">
                <span class="elapsed-time">{{ formatTime(total_time) }}</span>
                <span class="text-muted small" style="color: black; font-size: 1rem;"> / {{ formatTime(total_max_time) }} </span>
              </span>
            </li>

            <li id="overtime" v-if="item_time - item_max_time > 0 && meeting_state <= meeting_items.length" class="nav-item">
              <span>
                <span class="align-center small" style="color: white;"><i class="ti-alert"></i></span>
                <span class="align-center small" style="color: white;"> {{ formatTime(item_time - item_max_time) }}</span>
              </span>
            </li>

            <li class="nav-item">
              <span class="align-center text-info"><router-link to="/dashboard" class="font-bold large" style="color: #1bb5eb"><i class="ti-close"></i></router-link></span>
            </li>
          </ul>

          <!-- ============================================================== -->
          <!-- User profile and search -->
          <!-- ============================================================== -->
        </div>
      </nav>
    </header>
    <!-- ============================================================== -->
    <!-- End Topbar header -->
    <!-- ============================================================== -->
    <!-- ============================================================== -->
    <!-- Left Sidebar - style you can find in sidebar.scss  -->
    <!-- ============================================================== -->
    <aside class="left-sidebar">
      <!-- Sidebar scroll-->
      <div class="scroll-sidebar">
        <!-- Sidebar navigation-->
        <nav class="sidebar-nav">
          <ul id="sidebarnav">
            <li>
              <router-link to="/dashboard" active-class="active" class="waves-effect waves-dark" aria-expanded="false">
                <i class="ti-view-grid"></i><span class="hide-menu">{{ $t("Dashboard") }}</span>
              </router-link>
            </li>
            <li>
              <router-link to="/actions" active-class="active" class="waves-effect waves-dark" aria-expanded="false">
                <i class="ti-check-box"></i><span class="hide-menu">{{ $t("My Actions") }}</span>
              </router-link>
            </li>
            <li>
              <router-link to="/meetings" active-class="active" class="waves-effect waves-dark active" aria-expanded="false">
                <i class="ti-calendar"></i><span class="hide-menu">{{ $t("My Meetings") }}</span>
              </router-link>
            </li>
            <li>
              <router-link to="/reports" active-class="active" class="waves-effect waves-dark" aria-expanded="false">
                <i class="ti-bar-chart"></i><span class="hide-menu">{{ $t("Reports") }}</span>
              </router-link>
            </li>
            <li>
              <router-link to="/profile" active-class="active" class="waves-effect waves-dark" aria-expanded="false">
                <i class="ti-user"></i><span class="hide-menu">{{ $t("Profile") }}</span>
              </router-link>

            </li>
          </ul>
        </nav>
        <!-- End Sidebar navigation -->
      </div>
      <!-- End Sidebar scroll-->
    </aside>
    <!-- ============================================================== -->
    <!-- End Left Sidebar - style you can find in sidebar.scss  -->
    <!-- ============================================================== -->
    <!-- ============================================================== -->
    <!-- Page wrapper  -->
    <!-- ============================================================== -->
    <div id="wrapper" class="page-wrapper">
      <div id="container-base" class="container-fluid">
        <div class="row meeting-outer-container">

          <!-- Normal meeting card -->
          <div v-if="meeting_state <= meeting_items.length && meeting_items.length > 0" class="col-md-12 meeting-item-col col-modified" :class="col_size">
            <div class="card card-modified" :style="maxheight">
              <div class="card-body card-body-modified">

                <div>
                  <div class="row row-custom col-12">
                    <div :class="{'col-6' : windowWidth > 1400}">
                      <h1 id="itemtitle">{{ meeting_state + 1}}. {{ meeting_items[meeting_state]["name"] }}</h1>
                    </div>
                    <div class="text-muted timer" :class="{'col-6' : windowWidth > 1400}">
                      <div>
                        <ul class="button-list">
                          <li class="button-item timer-item">
                            <div>
                              <i class="ti-timer col-md-1"></i>
                            </div>
                          </li>
                          <li class="button-item time-elapsed">
                            <div>
                          <span>
                          <span style="font-size: 1.5em"
                                v-bind:class="{'text-danger': item_time > item_max_time }">
                            {{ formatTime(item_time) }}
                          </span>
                        </span>
                            </div>
                          </li>
                          <li class="button-item small-time">
                            <div>&nbsp;/&nbsp;{{ formatTime(item_max_time) }}</div>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>

                  <hr style="display: block;">
                  <h3 v-if="meeting_items[meeting_state]['description'] !== null" class="text-sub" v-html="meeting_items[meeting_state]['description']"></h3>
                  <h3 v-else class="text-sub" v-html="meeting_items[meeting_state]['description_alt']"></h3>
                  <hr>
                  <div class="buttons-bottom">

                    <button v-show="meeting_state > 0 && meeting_state < meeting_items.length" @click="goBackMeeting"
                       class="button btn-rounded btn-outline-secondary btn-large"><i class="ti-arrow-left"></i> <template v-if="windowWidth > 768">{{ $t("Back") }}</template></button>
                    <button v-if="meeting_state < meeting_items.length - 1" @click="proceedMeeting"
                       class="button btn-rounded btn-info btn-large"><template v-if="windowWidth > 768">{{ $t("Proceed") }}</template> <i class="ti-arrow-right"></i></button>
                    <button v-else-if="meeting_state >= meeting_items.length - 1" @click="closeMeeting"
                       class="button btn-rounded btn-info btn-large">{{ $t("Finish") }}<i class="ti-arrow-right"></i></button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Meeting is finished card -->
          <div v-if="meeting_state >= meeting_items.length && meeting_items.length > 0"
               class="mx-auto col-lg-4 col-md-8 col-sm-12 meeting-item-col"
               style="padding-top: 2rem;"
               :style="maxheight">
            <div class="card">
              <div class="card-body text-center">

                <div class="row" style="display: block !important;">
                  <div>
                    <h1 class="text-success checkmark"><i class="ti ti-check text-success"></i></h1>
                    <h2 class="h2title">{{ $t("Thank you") }}</h2>
                    <p class="text-sub text-muted pad-button">{{ $t("This meeting is finished") }}</p>
                  </div>
                </div>

                <a @click="finishMeeting" class="button btn-rounded btn-info"><i class="ti ti-close"></i> {{ $t("Close meeting") }}</a>

              </div>
            </div>
          </div>

          <!-- custom components -->
          <div id="customcomps" v-if="meeting_state <= meeting_items.length && dynamic_components.length > 0" class="widget-div col-md-12" :style="maxheight" :class="col_size">
            <div class="col-12">
              <div class="row widgets-row">
                <component v-for="comp in dynamic_components" :class="col_small" v-if="comp.name === 'kpi-widget' || comp.name === 'kbi-widget'" :key="comp.id" v-bind:is="comp.name" v-bind="comp.props">
                </component>
              </div>
            </div>
            <div v-for="comp in dynamic_components">
              <component v-if="(comp.name !== 'kpi-widget' && comp.name !== 'kbi-widget')" :key="comp.id" v-bind:is="comp.name" v-bind="comp.props">
              </component>
            </div>
          </div>
        </div>
      </div>
    </div>

    <add-action-modal v-if="showModal" :meeting="meeting_data.uid" v-on:actionAdded="addAction"></add-action-modal>

  </div>
</template>

<script>
  import apiHelper from "../mixins/APIHelper";
  import KPIWidget from "./KPIWidget";
  import KBIWidget from "./KBIWidget";
  import MeetingWidget from "./MeetingWidget";
  import AttendeesWidget from "./AttendeesWidget";
  import ActionMeetingWidget from "./ActionsMeetingWidget";
  import ContentWidget from "./ContentWidget";
  import HappyMeterWidget from "./HappyMeterWidget";
  import PerformanceWidget from "./PerformanceWidget";
  import AddActionModal from "./AddActionModal";
  import CheckListWidget from "./CheckListWidget";

  export default {
    name: "meetinghold",
    components: {
      "happy-widget": HappyMeterWidget,
      "content-widget": ContentWidget,
      "kpi-widget": KPIWidget,
      "kbi-widget": KBIWidget,
      "meeting-widget": MeetingWidget,
      "attendees-widget": AttendeesWidget,
      "action-meeting-widget": ActionMeetingWidget,
      "performance-widget": PerformanceWidget,
      "add-action-modal": AddActionModal,
      "checklist-widget": CheckListWidget,
    },
    data: function () {
      return {
        meetingID: this.$route.params.id,
        user: apiHelper.getUserData(),
        meeting_view: true,
        meeting_data: [],
        meeting_items: [],
        meeting_info: [],
        meeting_attendees: [],
        meeting_facilitator: [],
        meeting_state: 0,
        dynamic_components: [],
        item_time: 0,
        item_max_time: 0,
        total_time: 0,
        total_max_time: 0,
        showModal: false,
        interval: null,
        showNavbar: false,
        windowWidth: 0,
        windowHeight: 0,
        maxheight: 0,
        hrwidth: 0,
        col_size: "col-lg-6",
        col_small: "col-6",
        meeting_done: false,
        meeting_users: []
      }
    },
    created() {
      let vm = this;

      if (localStorage.getItem('expires') < (Math.floor(moment().unix() / 1000))) {
        vm.logUserOut();
      }

      vm.getMeetingData();
      this.$on('close', function (data) {
        vm.showModal = false;
      });
    },
    mounted(){
      this.$nextTick(function () {
        window.addEventListener('resize', this.getWindowWidth);
        window.addEventListener('resize', this.getWindowHeight);

        //Init
        this.getWindowWidth();
        this.getWindowHeight();

        if (!document.body.classList.contains('mini-sidebar')) {
          this.toggleSidebar();
        }
      });
    },
    beforeDestroy: function () {
      let vm = this;
      clearInterval(this.interval);
      window.removeEventListener('resize', this.getWindowWidth);
      window.removeEventListener('resize', this.getWindowHeight);

      if (vm.meeting_done) {
        localStorage.removeItem("meeting_uid");
        localStorage.removeItem("total_time");
        localStorage.removeItem("total_max_time");
        localStorage.removeItem("meeting_state");
      } else {
        localStorage.setItem("meeting_state", vm.meeting_state);
      }
    },
    methods: {
      getWindowWidth(event) {
        this.windowWidth = document.documentElement.clientWidth;

        if (!(document.body.classList).contains("mini-sidebar") && this.windowWidth < 1400) {
          this.toggleSidebar();
        }
        //
        // if (this.windowWidth < 1250) {
        //   this.col_size = "col-lg-12";
        // } else {
        //   this.col_size = "col-lg-6";
        // }

        if (this.windowWidth < 1250 && this.windowWidth > 992) {
          this.col_small = "col-12";
        } else  if (this.windowWidth < 992 && this.windowWidth > 630) {
          this.col_small = "col-6";
        } else if (this.windowWidth < 630) {
          this.col_small = "col-12";
        } else {
          this.col_small = "col-6";
        }

      },

      getWindowHeight(event) {
        this.windowHeight = document.documentElement.clientHeight;
        let diff = this.$refs['topbar'].clientHeight;

        if (this.windowWidth <= 992) {
          this.maxheight = "minheight: " + (this.windowHeight - diff) + "px;";
        } else {
          this.maxheight = "height: " + (this.windowHeight - diff) + "px;";
        }
      },

      addAction: function (event) {
        let actionToAdd = event;
        actionToAdd.status = "pending";
        let actionWidget = this.$children.find((child) => child.constructor.options.name === "actions-meeting-widget");
        if(typeof actionWidget !== 'undefined') {
          actionWidget.actionData.unshift(actionToAdd);
        }
      },

      toggleSidebar(){
        let vm = this;
        const body = document.body;
        if((body.classList).contains("mini-sidebar")) {
          body.classList.remove("mini-sidebar");
          vm.showNavBar = true;
        } else {
          body.classList.add("mini-sidebar");
          vm.showNavbar = false;
        }
      },

      logUserOut: function () {
        localStorage.clear();
        this.$router.push("/login");
      },

      // Grabs the meeting data
      getMeetingData() {
        let vm = this;

        apiHelper.getResource("/api/meeting/" + vm.meetingID + "/view").then((data) => {
          if (data.status === 404) {
            vm.$notify({
              group: "notification",
              title: vm.$t("Error"),
              text: vm.$t("Something went wrong, please try again."),
              type: 'error'
            });
            vm.$router.push("/dashboard");
            return;
          } else if (data.Facilitator["uid"] !== vm.user["uid"]) {
            vm.$notify({
              group: "notification",
              title: vm.$t("Error"),
              text: vm.$t("You're not the facilitator of this meeting."),
              type: 'error'
            });
            vm.$router.push("/meeting/" + vm.meetingID);
            return;
          }

          vm.meeting_data = data;
          vm.meeting_items = data.MeetingItems;
          vm.meeting_info = data.MeetingNorm;
          vm.meeting_attendees = data.AttendeeList;
          vm.meeting_facilitator = data.Facilitator;

          let startTime = moment(vm.meeting_data["date_start"]);
          let endTime = moment(vm.meeting_data["date_end"]);
          vm.total_max_time = Math.floor((endTime - startTime) / 1000);

          if (typeof vm.total_max_time !== "number") {
            vm.total_max_time = 0;
          }

          localStorage.setItem("total_max_time", vm.total_max_time);
          localStorage.setItem("meeting_name", vm.meeting_info["name"]);
          localStorage.setItem("meeting_id", vm.meetingID);

          // If this meeting has already been started go to the correct item else start the meeting
          if (vm.meeting_data['date_started'] !== null && vm.meeting_data['date_ended'] === null) {;
            if (typeof localStorage.getItem("meeting_state") === "number") {
              vm.meeting_state = Number(localStorage.getItem("meeting_state"));
              vm.getTime();
            } else {
              // Meeting has already started, so search through the start times to find the last item opened and move there

              apiHelper.getResource("/api/meeting/" + vm.meetingID + "/time-elapsed").then((data) => {
                let items1 = data["items"];
                setTimeout(1000,
                  apiHelper.getResource("/api/meeting/" + vm.meetingID + "/time-elapsed").then((data) => {
                    let items2 = data["items"];
                    let keys = Object.keys(items1);

                    for (let i = 0; i < keys.length; i++) {
                      if (items1[keys[i]] !== items2[keys[i]]) {
                        vm.meeting_state = i;
                        break;
                      } else if (items1[keys[i]] === 0) {
                        vm.meeting_state = i - 1;
                        break;
                      } else {
                        vm.meeting_state = i;
                      }
                    }

                    vm.item_time = items2[keys[vm.meeting_state]];
                    vm.item_max_time = vm.meeting_items[vm.meeting_state]["duration"];
                    vm.total_time = data["meeting"];
                    localStorage.setItem("total_time", vm.total_time);
                    if (vm.interval === null) {
                      vm.interval = setInterval(() => vm.itemTimer(), 1000);
                    }
                    vm.selectWidgets();
                  })
                );
              });
            }
          } else if (vm.meeting_data['date_ended'] !== null) {
            localStorage.removeItem("total_time");
            localStorage.removeItem("total_max_time");
            localStorage.removeItem("meeting_id");
            localStorage.removeItem("meeting_name");
            vm.$router.push('/meeting/' + vm.meetingID);
          }else {
            apiHelper.patchResource("/api/meeting/" + vm.meetingID + "/start").then((data) => {
              apiHelper.putResource("/api/meeting-item/" + vm.meeting_items[vm.meeting_state]["uid"] + "/track-time" ).then((data) => {
                vm.getTime();
              });
            });
          }
          if (vm.interval === null) {
            vm.interval = setInterval(() => vm.itemTimer(), 1000);
          }
          vm.selectWidgets();
        });
      },

      // Gets the time per item and syncs the meeting / item time with the server
      getTime() {
        let vm = this;

        apiHelper.getResource("/api/meeting/" + vm.meetingID + "/time-elapsed").then((data) => {
          let items = data["items"];
          let keys = Object.keys(items);

          vm.item_time = items[keys[vm.meeting_state]];
          vm.item_max_time = vm.meeting_items[vm.meeting_state]["duration"];
          vm.total_time = data["meeting"];
          localStorage.setItem("total_time", vm.total_time);
        })
      },

      // Go back to the previous meeting item
      goBackMeeting() {
        let vm = this;

        if (vm.meeting_state > 0) {
          vm.meeting_state -= 1;

          apiHelper.putResource("/api/meeting-item/" + vm.meeting_items[vm.meeting_state + 1]["uid"] + "/track-time" ).then((data) => {
            apiHelper.putResource("/api/meeting-item/" + vm.meeting_items[vm.meeting_state]["uid"] + "/track-time" ).then((data) => {
              vm.getTime();
            });
          });

          localStorage.setItem("meeting_state", String(vm.meeting_state));
          vm.selectWidgets();
        }
      },

      // Go to the next meeting item
      proceedMeeting() {
        let vm = this;

        if (vm.meeting_state < vm.meeting_items.length - 1) {
          vm.meeting_state += 1;

          apiHelper.putResource("/api/meeting-item/" + vm.meeting_items[vm.meeting_state - 1]["uid"] + "/track-time" ).then((data) => {
            apiHelper.putResource("/api/meeting-item/" + vm.meeting_items[vm.meeting_state]["uid"] + "/track-time" ).then((data) => {
              vm.getTime();
            });
          });

          localStorage.setItem("meeting_state", String(vm.meeting_state));
          vm.selectWidgets();

        }
      },

      // End the meeting
      closeMeeting() {
        let vm = this;

        apiHelper.putResource("/api/meeting-item/" + vm.meeting_items[vm.meeting_state]["uid"] + "/track-time" ).then((data) => {
          apiHelper.patchResource("/api/meeting/" + vm.meetingID + "/end").then((data) => {
            vm.meeting_state += 2;
            clearInterval(vm.interval);
            vm.meeting_done = true;
            vm.interval = null;
            localStorage.removeItem("meeting_uid");
            localStorage.removeItem("total_time");
            localStorage.removeItem("total_max_time");
            localStorage.removeItem("meeting_state");
          });
        });
      },

      finishMeeting() {
        let vm = this;

        localStorage.removeItem("meeting_uid");
        localStorage.removeItem("total_time");
        localStorage.removeItem("total_max_time");
        localStorage.removeItem("meeting_state");

        vm.$router.push('/dashboard');
      },

      // Select the widget for the current meeting item
      selectWidgets() {
        let vm = this;

        vm.dynamic_components = [];

        // Loops over the widgets and selects the good names for them
        vm.meeting_items[vm.meeting_state]["MeetingNormItem"]["_Widgets"].forEach(function (widget) {
          let name = widget.widget;
          let id = widget.meeting_norm_item_widget_id;
          let att = JSON.parse(JSON.stringify(vm.meeting_attendees));
          let users = JSON.parse(JSON.stringify(vm.meeting_users));
          switch (name) {
            case 'attendees':
              let attendees_props = {"attendees": att, "meeting_uid": vm.meetingID};
              vm.dynamic_components.push({'id': id, 'name': 'attendees-widget', 'props': attendees_props});
              break;
            case 'performance':
              let performance_props = {"content": widget.Content};
              vm.dynamic_components.push({'id': id, 'name': 'performance-widget', 'props': performance_props});
              break;
            case 'kbi':
              let kbi_props = {"data_kbi": widget.Content};
              vm.dynamic_components.push({'id': id, 'name': 'kbi-widget', 'props': kbi_props});
              break;
            case 'meetings':
              vm.dynamic_components.push({'id': id, 'name': 'meeting-widget'});
              break;
            case 'actions':
              let action_props = {"action_data": widget.Content};
              vm.dynamic_components.push({'id': id, 'name': 'action-meeting-widget', props: action_props});
              break;
            case 'tool_happy':
              let happy_props = {"attendees": users, "meeting": vm.meetingID};
              vm.dynamic_components.push({'id': id, 'name': 'happy-widget', props: happy_props});
              break;
            case 'content':
              let contentProps = {"content-data": widget.Content};
              vm.dynamic_components.push({'id': id, 'name': 'content-widget', props: contentProps});
              break;
            case 'checklist':
              const checklist_props = {"checklist_items": widget.Content, "meeting_uid": vm.meetingID, "widget_uid": widget.uid, enabled: true};
              vm.dynamic_components.push({'id': id, 'name': 'checklist-widget', props: checklist_props});
              break;
            case 'kpi':
              let kpi_props = {"kpi-data": widget.Content};
              vm.dynamic_components.push({'id': id, 'name': 'kpi-widget', props: kpi_props});
              break;
          }
        });
      },

      // Formats an amount of second into a nice timestring
      formatTime(time) {
        let vm = this;

        let s = time % 60;
        let m = ((time - s) / 60) % 60;

        let h = (time - ((m * 60) + s)) / 3600;
        let final = '';

        s = vm.padTime(s);
        m = (h > 0 ? vm.padTime(m) : m);
        if (h !== 0) {
          final = h + ':';
        }

        final += m + ':' + s;

        return final;
      },

      // "pad" the tame with leading zero's
      padTime(time) {
        return (time < 10 ? '0' : '') + time;
      },

      // The timer that keeps counting
      itemTimer() {
        let vm = this;

        vm.total_time = Number(vm.total_time) + 1;
        localStorage.setItem("total_time", vm.total_time);
        vm.item_time = Number(vm.item_time) + 1;
      }
    }
  }
</script>

<style scoped>
  .btn-large {
    font-size: 14pt !important;
  }

  .btn-small {
    font-size: 11pt !important;
  }

  .subtitle {
    font-size: 1rem !important;
  }

  .checkmark {
    font-size: 10rem;
  }

  .h2title {
    font-size: 3rem;
  }

  .pad-button {
    padding-top: 1rem;
    padding-bottom: 1rem;
  }
  #time{
    min-width: 250px;
  }

  #overtime {
    background-color: #e90042;
    min-width: 100px;
  }

  #container-base {
    padding: 0;
  }

  #wrapper {
    padding-bottom: 0;
  }

  .card-modified {
    margin-bottom: 0;
    border: none !important;
  }

  .col-modified {
    padding-left: 0;
  }

  .card-body-modified {
    padding: 4rem;
  }

  .btn-rounded > span{
    padding: 15px 30px;
  }

  @media screen and (min-width: 768px){
    .btn-rounded{
      margin: 0 .5rem;
    }
  }

  @media screen and (max-width: 767px){
    .btn-rounded:last-child{
      float: right;
      margin-right: 1rem;
    }
  }

  .row-custom {
    justify-content: space-between;
    margin-left: 0;
    margin-right: 0;
    padding-left: 0;
  }

  .row-custom > div.col-6 {
    padding-left: 0;
  }

  .buttons-bottom {
    position: absolute;
    bottom: 5%;
    font-size: 1.75rem;
    width: 100%;
    padding-right: 8rem;
  }

  #customcomps {
    padding-top: 2rem;
    padding-bottom: 25px;
  }

  .buttons-bottom > hr {
    padding-bottom: 1rem;
  }

  .timer-item{
    margin-top: 9px;
  }

  .small-time{
    margin-top: 9px;
  }

  .time-elapsed{
    min-width: 70px;
  }

  .time-elapsed > div{
    text-align: left;
  }

  .button-list{
    display: inline-block;
    float: right;
  }
  .elapsed-time{
    display: inline-block;
    min-width: 100px;

  }

  @media screen and (max-width: 1400px) {
    #meeting-type {
      display: none;
    }

    #overtime {
      display: none;
    }

    .buttons {
      display: none;
    }
  }

  @media screen and (max-width: 992px) {
    .buttons-bottom {
      font-size: initial;
    }

    .buttons-bottom > hr {
      padding-bottom: 0;
    }

    .text-sub {
      min-height: 6.5rem;
    }
  }

  @media screen and (max-width: 750px) {
    #customcomps {
      padding-left: 30px;
    }

    .col-12 {
      padding-left: 0;
    }
  }

  @media screen and (max-width: 675px) {
    #time {
      display: none;
    }

    #itemtitle {
      font-size: 1.5rem;
    }

    #title {
      font-size: 1rem;
    }
  }

  @media screen and (max-width: 400px) {
    .card-body-modified {
      padding: 2rem;
      margin: 0;
    }

    .buttons-bottom{
      position: static;
      margin-top: 32px;
      padding-right: 0;
      width: 100%;
    }

    .col-modified {
      padding-right: 50px;
    }

    .text-sub {
      min-height: 6.5rem;
    }

    .timer {
      margin-bottom: 1rem;
    }

    .timer .button-list{
      margin-left: -16px;
    }
  }
</style>
<style lang="scss">
  @import "../assets/scss/default-dark";
</style>



// WEBPACK FOOTER //
// src/components/MeetingHold.vue